export default "__VITE_ASSET__fce6647c__"